<template>
  <div class="py-3 border-b-2 bg-[#263159] border-[#bf9033] dark:border-gray-800 font-semibold h-[280px] flex items-center justify-center">
    <div
      class="px-6 max-w flex justify-center"
    >
      <NuxtImg
            src="/logo-home.png"
            width="400"
            height="180"
            alt="Logo da Thaís Baêta - Advocacia Trabalhista"
            quality="70"
            class="rounded-md"
          />
    </div>
  </div>
</template>
